/** The tasks Projects puts in people's task list (see Tasks). Projects sends its own notifications, so these don't. */
export const PROJECT_TASKS = [
    {
        key: "task", title: "Project tasks due soon", icon: "layers", sort: 40, level: "action", audience: "routed", clear: "fix", notify: false, link: "/projects",
        description: "Each of your open project tasks that's overdue or due in the next few days (Projects → Settings). Clears itself when the task is ticked off, moved or the project is finished.",
    },
    {
        key: "update", title: "Post a project update", icon: "layers", sort: 41, level: "info", audience: "routed", clear: "fix", notify: false, link: "/projects",
        description: "The owner of an active project hasn't posted a status update for a week (if weekly updates are on). Clears when they post one.",
    },
];
